import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'found';
import { commitMutation, graphql } from 'react-relay';
import { Loader } from '../Elements';

const OpenContract = class OpenContract extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
  }

  componentWillMount() {
    const onCompleted = response => {
      const { contract } = response.addContractToSession;
      this.props.router.push({
        pathname: `/docs/c/${contract.id}`,
        query: { share_token: this.props.params.share_token }
      });
    };

    const onError = () => {
      this.setState({ error: true });
    };

    const mutation = graphql`
      mutation OpenContractComponent_addContractToSessionMutation(
        $input: AddContractToSessionInput!
      ) {
        addContractToSession(input: $input) {
          contract {
            id
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { share_token } = this.props.params;

    commitMutation(environment, {
      mutation,
      variables: { input: { share_token } },
      onCompleted,
      onError
    });
  }

  render() {
    return (
      <div>
        {this.state.error &&
          <h1 style={{ textAlign: 'center', marginTop: '120px' }}>
            Page not found
          </h1>}
        {!this.state.error && <Loader />}
      </div>
    );
  }
};

export default withRouter(OpenContract);



// WEBPACK FOOTER //
// ./webpack/components/Share/OpenContractComponent.js